import { GoogleLogin } from "@react-oauth/google";
import { useCallback, useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useDispatch } from "react-redux";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Modal, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import getUsersCities from "../../../Hooks/getUsersCities";
import { toggleLoading } from "../../../Redux/reducers/loadingSlice";
import { changeSelectedCity } from "../../../Redux/reducers/selectedCitySlice";
import { changeUser } from "../../../Redux/reducers/userSlice";
import { toggleVerify } from "../../../Redux/reducers/verifySlice";
import { SELECTED_CITY, TOKEN_KEY } from "../../../Utils/Constants";
import { baseUrl } from "../../../shared/baseUrl";
import { createNotification } from "../../Common/CreateNotification";
import ForgotPassword from "./ForgotPassword";

const Login = ({ isOpen, activeIndex = "1", onClose }) => {
  const dispatch = useDispatch();
  const [isMounted, setIsMounted] = useState(false);
  const [isFirst, setIsFirst] = useState(true);

  const [activeTab, setActiveTab] = useState("1");
  const [fp_open, set_fp_open] = useState(false);

  const [city, setCity] = useState("");
  const [cityOption, setCityOption] = useState("");

  // Sign Uo
  const [su_name, set_su_name] = useState("");
  const [su_email, set_su_email] = useState("");
  const [su_contact, set_su_contact] = useState("");
  const [su_password, set_su_password] = useState("");
  const [su_confirm_password, set_su_confirm_password] = useState("");

  // Sign In
  const [si_email, set_si_email] = useState("");
  const [si_password, set_si_password] = useState("");

  useEffect(() => {
    setActiveTab(activeIndex);
  }, [activeIndex]);

  const getCitiesOptions = useCallback(async () => {
    if (isMounted || isFirst) {
      const userCities = await getUsersCities();
      setCityOption(userCities);
      setIsFirst(false);
    }
  }, [isFirst, isMounted]);
  useEffect(() => {
    setIsMounted(true);
    getCitiesOptions();
    return () => {
      setIsMounted(false);
    };
  }, [getCitiesOptions]);



  const animatedComponents = makeAnimated();

  const handleSignUp = async (e) => {
    e.preventDefault();
    dispatch(toggleLoading(true));

    await fetch(baseUrl + "register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: su_name,
        email: su_email,
        password: su_password,
        password_confirmation: su_confirm_password,
        device: "NaN",
        city: city,
        contact: su_contact,
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success) {
          localStorage.setItem(TOKEN_KEY, JSON.stringify(res.user));
          createNotification("success", "Registration Successful");
          dispatch(changeUser(res.user));
          onClose();
          dispatch(toggleVerify(true));
          dispatch(toggleLoading(false));
          localStorage.setItem(
            SELECTED_CITY,
            JSON.stringify({ label: "All", value: -1 })
          );
          dispatch(changeSelectedCity({ label: "All", value: -1 }));
        } else {
          createNotification("error", res.message);
          dispatch(toggleLoading(false));
        }
      })
      .catch((e) => {
        createNotification("error", "Registration Failed");
        dispatch(toggleLoading(false));
      });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    dispatch(toggleLoading(true));

    await fetch(baseUrl + "login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: si_email,
        password: si_password,
        device: "NaN",
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success) {
          localStorage.setItem(TOKEN_KEY, JSON.stringify(res.user));
          createNotification("success", "Login Successful");
          dispatch(changeUser(res.user));
          onClose();
          dispatch(toggleLoading(false));
          localStorage.setItem(
            SELECTED_CITY,
            JSON.stringify({ label: "All", value: -1 })
          );
          dispatch(changeSelectedCity({ label: "All", value: -1 }));
        } else {
          createNotification("error", res.message);
          dispatch(toggleLoading(false));
        }
      })
      .catch((e) => {
        createNotification("error", "Login Failed");
        dispatch(toggleLoading(false));
      });
  };

  const googleLogin = async (accessToken) => {
    dispatch(toggleLoading(true));

    await fetch(baseUrl + "auth/google", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        credential: accessToken,
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success) {
          localStorage.setItem(TOKEN_KEY, JSON.stringify(res.user));
          createNotification("success", res.message);
          dispatch(changeUser(res.user));
          onClose();
          dispatch(toggleLoading(false));
          localStorage.setItem(
            SELECTED_CITY,
            JSON.stringify({ label: "All", value: -1 })
          );
          dispatch(changeSelectedCity({ label: "All", value: -1 }));
        } else {
          createNotification("error", res.message);
          dispatch(toggleLoading(false));
        }
      })
      .catch((e) => {
        createNotification("error", "Login Failed");
        dispatch(toggleLoading(false));
      });
  };

  // const login = useGoogleLogin({
  //   onSuccess: codeResponse => {
  //     googleLogin(codeResponse.access_token);
  //   }
  // });

  return (
    <div className="">
      <Modal isOpen={isOpen} className="position-relative main-modal" centered>
        <div
          onClick={onClose}
          className="position-absolute cursor-pointer"
          style={{ zIndex: 10, top: 6, right: 10 }}
        >
          <FaTimes size={20} />
        </div>
        <div className="p-3  sc-modal-content">
          <div>
            <Nav className="d-flex justify-content-center" tabs>
              <NavItem
                className="cursor-pointer active"
                onClick={() => {
                  setActiveTab("1");
                }}
              >
                <NavLink
                  style={{ color: activeTab !== "1" ? "#ec008c" : "inherit" }}
                  className={`${activeTab === "1" ? "active" : ""} fw-bold`}
                >
                  Login
                </NavLink>
              </NavItem>
              <NavItem
                className="cursor-pointer"
                onClick={() => {
                  setActiveTab("2");
                }}
              >
                <NavLink
                  style={{ color: activeTab !== "2" ? "#ec008c" : "inherit" }}
                  className={`${activeTab === "2" ? "active" : ""} fw-bold`}
                >
                  Sign Up
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1" className="py-3 tab-content">
                <form onSubmit={handleLogin} className="g-3" autoComplete="off">
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input
                      required
                      type="email"
                      className="form-control"
                      placeholder="Your Email Here!"
                      autoComplete="false"
                      value={si_email}
                      onChange={(e) => {
                        set_si_email(e.target.value);
                      }}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Password</label>
                    <input
                      required
                      type="password"
                      className="form-control"
                      placeholder="Your Password Here!"
                      autoComplete="false"
                      value={si_password}
                      onChange={(e) => {
                        set_si_password(e.target.value);
                      }}
                    />
                  </div>
                  <div className="d-flex flex wrap justify-content-between">
                    <button
                      disabled={
                        si_email !== "" && si_password !== "" ? false : true
                      }
                      type="submit"
                      className="btn btn-primary"
                    >
                      Login
                    </button>
                    <p
                      type="button"
                      onClick={() => {
                        set_fp_open(true);
                      }}
                      className="text-primary cursor-pointer my-auto small"
                    >
                      Forget Password?
                    </p>
                  </div>
                </form>
              </TabPane>
              <TabPane tabId="2" className="pt-3">
                <form
                  className="row g-3"
                  onSubmit={handleSignUp}
                  autoComplete="off"
                >
                  <div className="col-12">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Full Name"
                      autoComplete="false"
                      value={su_name}
                      onChange={(e) => {
                        set_su_name(e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      autoComplete="false"
                      value={su_email}
                      onChange={(e) => {
                        set_su_email(e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label">City</label>
                    {cityOption && (
                      <Select
                        // ref={selectBrandRef}
                        autoComplete={false}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        placeholder={"Select City"}
                        isMulti={false}
                        options={cityOption}
                        value={cityOption.find((u) => u.value === city)} // set selected values
                        onChange={(e) => {
                          if (e !== null) {
                            setCity(e.value);
                          }
                        }}
                      />
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Password"
                      autoComplete="false"
                      value={su_password}
                      onChange={(e) => {
                        set_su_password(e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Confirm Password</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Confirm Password"
                      autoComplete="false"
                      value={su_confirm_password}
                      onChange={(e) => {
                        set_su_confirm_password(e.target.value);
                      }}
                    />
                    <p
                      className={`small text-danger ${su_password !== "" &&
                        su_confirm_password !== "" &&
                        su_password !== su_confirm_password
                        ? ""
                        : "d-none"
                        }`}
                    >
                      Password doesn't match!
                    </p>
                  </div>
                  <div className="col-12">
                    <label className="form-label">Phone Number</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Phone Number"
                      value={su_contact}
                      onChange={(e) => {
                        set_su_contact(e.target.value);
                      }}
                    />
                  </div>
                  <p className="small d-flex gap-2">
                    By signing up, you agree to our <a target="_blank" rel="noopener noreferrer" className="text-primary" href="/terms-and-conditions">Terms and Conditions</a>
                  </p>
                  <div className="col-12 d-flex justify-content-center">
                    <button
                      type="submit"
                      disabled={
                        su_name !== "" &&
                          su_email !== "" &&
                          city !== "" &&
                          su_password !== "" &&
                          su_confirm_password !== "" &&
                          su_password === su_confirm_password
                          ? false
                          : true
                      }
                      className="btn btn-primary"
                    >
                      Sign Up
                    </button>
                  </div>
                </form>
              </TabPane>
            </TabContent>
          </div>
          <div className="d-flex align-items-center my-3">
            <hr style={{ color: "#00000090", width: "100%", height: 1 }} />
            <p className="my-auto px-3">OR</p>
            <hr style={{ color: "#00000090", width: "100%", height: 1 }} />
          </div>
          <div className="d-flex justify-content-center">
            <div className="text-center">

              <GoogleLogin
                onSuccess={(credentialResponse) => {
                  googleLogin(credentialResponse.credential);
                }}
                onError={() => {
                  console.log("Login Failed");
                }}
                useOneTap
                cookiePolicy="single_host_origin"
              />

            </div>
          </div>
        </div>
      </Modal>

      <ForgotPassword
        isOpen={fp_open}
        onClose={() => {
          set_fp_open(false);
        }}
      />
    </div>
  );
};

export default Login;
